import React, { useMemo } from "react";
import { ChevronDownIcon } from "@radix-ui/react-icons";
import { Card } from "../card";
import { RadixAccordion, RadixAccordionContent, RadixAccordionHeader, RadixAccordionItem, RadixAccordionTrigger, } from "../primitives/RadixAccordion";
import "./accountAccordion.css";
import { ChevronRightIcon } from "../icons";
var createAccordionItemValue = function (title) {
    var normalizedTitle = title
        .toLowerCase()
        .trim()
        .replace(/[^a-z0-9]+/g, "-")
        .replace(/^-+|-+$/g, "");
    return normalizedTitle || "account-section";
};
export var AccountAccordion = function (_a) {
    var icon = _a.icon, title = _a.title, children = _a.children, _b = _a.isExpanded, isExpanded = _b === void 0 ? true : _b, onToggle = _a.onToggle, _c = _a.disabled, disabled = _c === void 0 ? false : _c;
    var itemValue = useMemo(function () { return createAccordionItemValue(title); }, [title]);
    return (React.createElement(Card, { className: "account-accordion ".concat(isExpanded ? "account-accordion--expanded" : "account-accordion--collapsed", " ").concat(disabled ? "account-accordion--disabled" : "") },
        React.createElement(RadixAccordion, { type: "single", collapsible: true, value: isExpanded ? itemValue : "", onValueChange: function () {
                if (!disabled) {
                    onToggle === null || onToggle === void 0 ? void 0 : onToggle();
                }
            } },
            React.createElement(RadixAccordionItem, { value: itemValue },
                React.createElement(RadixAccordionHeader, { className: "account-accordion-heading" },
                    React.createElement("div", { className: "account-accordion-heading-main" },
                        React.createElement("span", { className: "account-accordion-icon", "aria-hidden": "true" }, icon),
                        React.createElement("h2", null, title)),
                    onToggle ? (React.createElement(RadixAccordionTrigger, { className: "account-accordion-toggle", "aria-label": "".concat(isExpanded ? "Collapse" : "Expand", " ").concat(title), disabled: disabled }, isExpanded ? React.createElement(ChevronDownIcon, null) : React.createElement(ChevronRightIcon, null))) : null),
                React.createElement(RadixAccordionContent, { className: "account-accordion-content" }, children)))));
};
